import { useState, Fragment, useEffect } from "react";

import Event from "../event/list";
import EventFieldMaker from "./EventFieldMaker";
import axios from "axios";
import AcademySelect from "../academy/select";
import omegaStyle from "../omega.module.css";

const uniqueCode = () => Date.now().toString(36) + Math.random().toString(36).substring(2, 9);

function EventMaker() {
	const [templates, setTemplates] = useState([]);
	const [templateId, setTemplateId] = useState("");
	const [hasForm, setHasForm] = useState(0);
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [fields, setFields] = useState([]);
	const [attributes, setAttributes] = useState({});

	const [branchList, Set_branchList] = useState([]);
	const [includeMode, Set_includeMode] = useState(false);
	const [isOpen, Set_isOpen] = useState(true);
	const [searchEvent, Set_searchEvent] = useState("");
    const [onlyEnrolled, Set_onlyEnrolled] = useState(false)

	useEffect(() => {
		get_event();
	}, []);

	async function get_event() {
		axios
			.post("/omega/form/load", {
				searchEvent: searchEvent,
			})
			.then((res) => {
				setTemplates(res.data);
			});
	}

	const addField = () => {
		setFields((prev) => [...prev, { code: uniqueCode(), type: "", options: [] }]);
	};

	const removeField = (code) => {
		setFields((prev) => prev.filter((f) => f.code !== code));
	};

	const updateField = (code, patch) => {
		// patch: { type? , options? }
		setFields((prev) => prev.map((f) => (f.code === code ? { ...f, ...patch } : f)));
	};

	const onSubmit = () => {
		if (name === "") {
			alert("행사 이름을 입력해 주세요.");
		} else if (
			(templateId === "" && window.confirm("등록하시겠습니까?")) ||
			(templateId !== "" && window.confirm("수정하시겠습니까?"))
		) {
			axios
				.post("/omega/form/save", {
					templateId,
					name,
					description,
					fields,
					attributes,
					branchList,
					includeMode,
					isOpen,
                    onlyEnrolled
				})
				.then((res) => {
					console.log(res.data);
					alert("등록되었습니다.");
					let newId = res.data.templateId;
					const template = templates.find((t) => t.id === Number(newId));
					if (template) {
						template.name = name;
						template.description = description;
						template.EventFields = fields;
						template.attributes = attributes;
					} else {
						templates.push({
							id: newId,
							name,
							description,
							EventFields: fields,
							attributes,
							updatedAt: new Date().toISOString(),
							isOpen: true,
                            onlyEnrolled: false,
                            includeMode: false,
                            branchList: []
						});
					}
					setTemplates([...templates]);
				});
		}
	};

	const changeTemplate = (e) => {
		const selectedId = e.currentTarget.id;
		if (selectedId !== "") {
			const template = templates.find((t) => t.id === Number(selectedId)); // id가 숫자면 변환
			console.log(templates);
			console.log(template);

			setTemplateId(template.id);
			setHasForm(template.hasForm);
			setName(template.name);
			setDescription(template.description || "");
			setAttributes(template.attributes || {});
			let currfields = template.EventFields.map((v) => {
				return { code: uniqueCode(), ...v };
			});
			setFields(currfields);
			Set_branchList(template["branchList"]);
			Set_includeMode(template["includeMode"]);
			Set_isOpen(template["isOpen"]);
            Set_onlyEnrolled(template["onlyEnrolled"])
		} else {
			setTemplateId("");
			setHasForm(0);
			setName("");
			setDescription("");
			setAttributes({});
			setFields([]);
			Set_branchList([]);
			Set_includeMode(false);
			Set_isOpen(true);
            Set_onlyEnrolled(false)
		}
	};

	const deleteTemplate = () => {
		if (window.confirm("삭제하시겠습니까?")) {
			axios.post("/omega/form/delete", { templateId }).then((res) => {
				alert("삭제되었습니다.");
				setName("");
				setDescription("");
				setTemplates((prev) => [...prev.filter((v) => v.id !== templateId)]);
				setFields([]);
				setTemplateId("");
				setAttributes({});
				setHasForm(0);
			});
		}
	};

	return (
		<div>
			<Event
				templates={templates}
				templateId={templateId}
				changeTemplate={changeTemplate}
				searchEvent={searchEvent}
				Set_searchEvent={Set_searchEvent}
				get_event={get_event}
			></Event>

			<div style={{ marginBottom: "10px" }}></div>

			<div style={{ marginBottom: "10px" }}>
				<button onClick={onSubmit}>
					{templateId === "" && <span>행사 등록</span>}
					{templateId !== "" && <span>행사 수정</span>}
				</button>
				{templateId !== "" && !hasForm && <button onClick={deleteTemplate}>행사 삭제</button>}
			</div>
			{/* <div>
                <select onChange={changeTemplate}>
                    <option value="">신규등록</option>
                    {templates.map((v, i) => (
                        <option key={i} value={v.id}>
                            {v.name}/{v.description}
                        </option>
                    ))}
                </select>
                {templateId !== "" && !hasForm && <button onClick={deleteTemplate}>삭제</button>}
            </div> */}

			{/* 1) 기본 메타 */}
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr 1fr 1fr",
					gap: 8,
					marginBottom: "10px",
					backgroundColor: "#EFEFEF",
					borderRadius: "5px",
					padding: "10px",
					boxSizing: "border-box",
				}}
			>
				<label style={{ display: "flex", flexDirection: "column" }}>
					<span>행사 이름</span>
					<input type="text" value={name} onChange={(e) => setName(e.target.value)} />
				</label>

				<label style={{ display: "flex", flexDirection: "column" }}>
					<span>행사 설명</span>
					<input type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
				</label>

				<label style={{ display: "flex", alignItems: "center" }}>
					<span>행사 공개</span>
					<input type="checkbox" checked={isOpen} onChange={(e) => Set_isOpen(e.currentTarget.checked)}></input>
				</label>

                <label style={{ display: "flex", alignItems: "center" }}>
                    <span>재원생만</span>
                    <input type="checkbox" checked={onlyEnrolled} onChange={(e) => Set_onlyEnrolled(e.currentTarget.checked)}></input>
                </label>
			</div>
			{/* 여기 */}

			<AcademySelect
				templateId={templateId}
				branchList={branchList}
				Set_branchList={Set_branchList}
				includeMode={includeMode}
				Set_includeMode={Set_includeMode}
			></AcademySelect>

			{/* 여기 */}
			<div style={{ marginBottom: "10px" }}>
				<button onClick={addField}>필드 추가</button>
			</div>

			<div
				style={{
					backgroundColor: "#EFEFEF",
					borderRadius: "5px",
					padding: "10px",
					boxSizing: "border-box",
				}}
			>
				{fields.map((field) => (
					<Fragment key={field.code}>
						<EventFieldMaker
							field={field}
							onPatch={(code, patch) => updateField(code, patch)} // 이미 있으니 그대로 사용
							onRemove={(code) => removeField(code)}
						/>
					</Fragment>
				))}

				{fields.length === 0 && <div>추가한 필드가 없습니다.</div>}
			</div>
		</div>
	);
}

export default EventMaker;
